export default __webpack_public_path__ + "static/media/2_0148.52e19382.webp";